import { PawPrint } from 'lucide-react';
import RecordManager from '../components/RecordManager';

export default function PetCare() {
  return (
    <RecordManager
      apiPath="pet-care"
      testid="petcare"
      title="Pet Care Instructions"
      subtitle="Make sure your beloved companions are always cared for."
      icon={PawPrint}
      accent="gold"
      addLabel="Add Pet"
      emptyText="No pets added yet. Record care details so your companions are always looked after."
      titleField="pet_name"
      subtitleFields={['species', 'breed', 'caretaker', 'vet_name']}
      hasPhoto
      fields={[
        { name: 'pet_name', label: 'Pet name', placeholder: 'e.g., Bella' },
        { name: 'species', label: 'Species', type: 'select', options: ['Dog', 'Cat', 'Bird', 'Fish', 'Reptile', 'Small animal', 'Other'] },
        { name: 'breed', label: 'Breed', placeholder: 'e.g., Golden Retriever' },
        { name: 'caretaker', label: 'Who will care for them', placeholder: 'Name of trusted caretaker' },
        { name: 'vet_name', label: 'Veterinarian', placeholder: 'Vet / clinic name' },
        { name: 'vet_phone', label: 'Vet phone', placeholder: 'Phone number' },
        { name: 'feeding_instructions', label: 'Feeding instructions', type: 'textarea', placeholder: 'Food, schedule, portions, treats…' },
        { name: 'medications', label: 'Medications & health', type: 'textarea', placeholder: 'Medications, allergies, conditions.' },
        { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Favorite toys, routines, personality…' },
      ]}
    />
  );
}
